<template>
	<span v-if="props.type == 'project'" class="__status" :class="_class">
		<Disc2 class="__status_icon" />
	</span>
	<span v-else-if="props.type == 'location'" class="__status" :class="_class">
		<MapPin class="__status_icon" />
		<!-- < class="__status_icon" /> -->
	</span>
	<span v-else-if="props.type == 'hub'" class="__status" :class="_class">
		<Boxes class="__status_icon" />
	</span>
	<span v-else-if="props.type == 'module'" class="__status" :class="_class">
		<Hexagon class="__status_icon" />
	</span>
	<span v-else-if="props.type == 'comapp'" class="__status" :class="_class">
		<RadioReceiver class="__status_icon" />
	</span>
	<span v-else-if="props.type == 'graph'" class="__status text-secondary">
		<ChartSpline class="__status_icon" />
	</span>
	<span v-else-if="props.type == 'sensor'" class="__status_icon">
		<Asterisk class="__status_icon" />
	</span>
</template>
<script setup lang="ts">
	import { computed, ref } from 'vue'
	
	import { useBaseStore } from '@/stores/base.store'
	import { Boxes, ChartSpline, Disc2, Hexagon, MapPin, RadioReceiver, Asterisk } from 'lucide-vue-next'

	const baseStore = useBaseStore()
	const allStates = computed(() => baseStore.allStates)

	const _status = computed(() => allStates.value?.[props.type + 's']?.[props._id] || 'unknown')
	const _class = computed(() => {
		if (!_status.value || _status.value == 'unknown') return '_white'
		else if (_status.value == 'ok') return '_green'
		else if (_status.value == 'alert') return '_redBlink'
		else if (_status.value == 'warning') return '_orange'
		else if (_status.value == 'deactivated') return '_black'
		else if (_status.value == 'no_modules') return '_greym'
		else if (_status.value == 'no_hubs') return '_greyl'
		else if (_status.value == 'no_locations') return '_greyd'
		return ''
	})
	// const _class = computed(() => statusLightClass(_status.value))
	const props = defineProps<{
		type: string // 'project' | 'location' | 'hub' | 'module' | 'comapp' | 'graph' | 'sensor'
		_id: string
	}>()
</script>

<style scoped>
	@reference '@/styles/tailwind.css';

	.__status {
		@apply relative inline-block;
		/* width: 1em;
		height: 1em; */

		/* .__status_icon {
			width: 1em;
			height: 1em;
		} */

		&.__ok {
			@apply text-teal-500;
		}

		&.__preWarn {
			@apply text-lime-400;
		}

		&.__warn {
			@apply text-amber-500;
		}

		&.__preAlert {
			@apply text-orange-600;
		}

		&.__warnPreAlert {
			@apply text-orange-800;
		}

		&.__alert {
			@apply text-red-600;
		}

		&._large {
			width: 18px;
			height: 18px;
			min-width: 18px;
		}

		&._green {
			@apply text-green-500;
		}

		&._red {
			@apply text-red-500;
		}

		&._redBlink {
			@apply text-orange-600;
			animation-duration: 1000ms;
			animation-name: blink;
			animation-iteration-count: infinite;
			animation-direction: alternate;
		}

		&._blue {
			@apply text-cyan-600;
		}

		&._orange {
			@apply text-amber-500;
		}

		&._white {
			@apply text-white;
		}

		&._black {
			@apply text-slate-500/60;
		}

		&._greyl {
			@apply text-gray-400;
		}

		&._greym {
			@apply text-gray-600;
		}

		&._greyd {
			@apply text-gray-800;
		}
	}
</style>
